export default __webpack_public_path__ + "static/media/get-inspired-blue.1708a106.svg";